<template>
  <div v-if="canRender" class="container">
    <div class="row">
      <div class="ratings-reviews-container">
        <h2>{{ carouselRatingsData.productreviewtitle }}</h2>
        <div class="logo-description-container">
          <div class="inner-container">
            <h3>{{ carouselRatingsData.productreviewdescription }}</h3>
            <div class="image-container">
              <img :src="carouselRatingsData.bazaarvoicelogo" alt="" />
              <div class="arrow-box" v-html="carouselRatingsData.logohelptext"></div>
            </div>
          </div>
        </div>

        <carousel
          v-if="carouselRatingsData.productreviewinfo.length"
          :rotate-tag="{ __eventType: 'click' }"
          :auto-rotate="false"
          go-to-slide-text="Go to slide"
          pause-carousel-text="pause carousel"
          play-carousel-text="play carousel"
          previous-slide-text="previous slide"
          next-slide-text="next slide"
          :pagination-enabled="false"
          :per-page="1"
          :scroll-per-page="false"
          :per-page-custom="perPageCustom"
        >
          <slide
            v-for="slider in carouselRatingsData.productreviewinfo"
            :key="slider"
            class="col-sm-12 col-md-4"
          >
            <div @click="navigateTo(slider.buttonlink)">
              <div class="mobile-centering">
                <div class="model-container">
                  <img
                    v-if="slider.gender === 'Male'"
                    src="/images/assets/avatar/MALE.png"
                    alt=""
                    :style="{ width: 90 + 'px', height: 90 + 'px' }"
                  />
                  <img
                    v-else
                    src="/images/assets/avatar/FEMALE.png"
                    alt=""
                    :style="{ width: 90 + 'px', height: 90 + 'px' }"
                  />
                  <p>{{ slider.username }}</p>
                  <p class="his-reviews">{{ slider.userratingtitle }}</p>
                </div>
                <!-- <div class="product-container">
              <img class="" :style="{ width: '100%',height:100 +'px'}"  :src="slider.productimage">
            </div> -->
                <div class="description-container">
                  <h5>{{ slider.usefavtitle }}</h5>
                  <div class="title-container">
                    <h4>{{ slider.producttitle }}</h4>
                    <h4>{{ slider.producttitlecategory }}</h4>
                  </div>
                  <star-rating
                    :increment="0.01"
                    :read-only="true"
                    active-color="#337ab7"
                    :border-width="3"
                    border-color="transparent"
                    :rounded-corners="true"
                    :rating="slider.userratings"
                    :star-size="30"
                    :star-points="[
                      23, 2, 14, 17, 0, 19, 10, 34, 7, 50, 23, 43, 38, 50, 36, 34, 46, 19, 31, 17,
                    ]"
                    :show-rating="false"
                  >
                  </star-rating>
                </div>
                <div style="clear: both"></div>
                <div style="clear: both"></div>
              </div>
            </div>
            <div class="bottom-container">
              <p>{{ slider.userreview }}</p>
              <div
                v-show="slider.buttontitle != ''"
                class="slider-image-button"
                @click="
                  datalayer(
                    carouselRatingsData.productreviewtitle,
                    slider.buttontitle,
                    slider.buttonlink,
                  )
                "
              >
                <a :href="slider.buttonlink" role="button" class="">
                  <strong>{{ slider.buttontitle }}</strong>
                </a>
              </div>
            </div>
          </slide>
        </carousel>
      </div>
    </div>
  </div>
</template>
<script>
import StarRating from 'vue-star-rating';
import otMixins from '../../mixins/ot-mixins';
import { EventBus } from '../../mixins/event';
import { OTConsentEmitters } from '../../mixins/constants';
/* eslint-disable */
export default {
  name: 'mixa-ratings-reviews',
  components: {
    StarRating,
  },

  mixins: [otMixins],

  props: {
    carouselRatingsData: {
      type: Array,
      required: false,
    },
    isConsentEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      perPageCustom: [],
      windowWidth: 0,
      canRender: false,
      otReviewEmitter: OTConsentEmitters.OTRatingsAndReviewsEmitter,
    };
  },
  computed: {
    // Conditionally apply the mixin based on the prop value
    mixinsToApply() {
      return this.isConsentEnabled ? [otMixins] : [];
    },
  },
  beforeCreate() {
    EventBus.$on(
      OTConsentEmitters.OTRatingsAndReviewsEmitter,
      (status) => (this.canRender = status),
    );
  },
  mounted() {
    //this.canRender = this.isConsentEnabled ? (EventBus.$on("cookiesStatusUpdate", status => this.canRender = status), false) : true;
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth);
      this.getWindowWidth();
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth);
  },
  methods: {
    navigateTo(url) {
      window.location.href = url;
    },
    datalayer(tittle, buttontittle, buttonurl) {
      dataLayer.push({
        event: 'uaevent',
        eventCategory: 'homepage',
        eventAction: `select::${tittle}`,
        eventLabel: `${buttontittle}::${buttonurl}`,
        ecommerce: undefined,
        event_name: 'body_button_click',
        module_name: tittle,
        cta_name: buttontittle,
        link_url: buttonurl,
      });
    },
    getWindowWidth() {
      this.windowWidth = document.documentElement.clientWidth;
      if (this.windowWidth <= 768) {
        this.perPageCustom = [[0, 1]];
      } else {
        this.perPageCustom = [[0, 3]];
      }
    },
  },
};
</script>
